export function getClientMetricValue(client, keys, fallback = null) {
  if (!client) return fallback;
  for (const key of keys) {
    const value = client[key];
    if (value !== undefined && value !== null && value !== "") {
      return value;
    }
  }
  return fallback;
}

export function getClientMetrics(client) {
  return {
    visits: Number(
      getClientMetricValue(
        client,
        ["visit_count_total", "visitCountTotal", "total_visits", "totalVisits", "visit_count", "visitCount"],
        0
      )
    ),
    spent: Number(
      getClientMetricValue(
        client,
        ["total_spend", "totalSpend", "lifetime_spend", "lifetimeSpend", "lifetime_net_spend", "lifetimeNetSpend"],
        0
      )
    ),
    lastVisitDate: getClientMetricValue(
      client,
      ["last_visit_date", "lastVisitDate", "last_visit", "lastVisit"],
      null
    ),
  };
}

function parseLocalDate(value) {
  if (!value) return null;
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }
  const raw = String(value).trim();
  const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) {
    return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  }
  const parsed = new Date(raw);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

export function formatClientSpent(value) {
  const amount = Number(value || 0);
  if (!Number.isFinite(amount)) return "$0";
  const rounded = Math.round(amount * 100) / 100;
  const hasCents = Math.abs(rounded % 1) > 0;
  return `$${rounded.toLocaleString(undefined, {
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: hasCents ? 2 : 0,
  })}`;
}

export function formatLastVisitAge(value, today = new Date()) {
  const visitDate = parseLocalDate(value);
  if (!visitDate) return "--";
  const todayDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const visitDay = new Date(
    visitDate.getFullYear(),
    visitDate.getMonth(),
    visitDate.getDate()
  );
  const days = Math.max(
    0,
    Math.round((todayDate.getTime() - visitDay.getTime()) / 86400000)
  );
  if (days === 0) return "Today";
  return `${days}d`;
}
